module.exports = __webpack_public_path__ + "img/icon3.2282f5b5.png";